export const MAP_OPTIONS = {
    types: ["address"],
    componentRestrictions: { country: "US" }
};
